import { schemaComponentIdForRuntimeComponent } from './component-aliases';
export const RUNTIME_SCHEMA_PROP_GUARDRAILS = Object.freeze({
    Heading: Object.freeze({
        color: Object.freeze({ allowRawStringValue: true }),
    }),
    Text: Object.freeze({
        color: Object.freeze({ allowRawStringValue: true }),
    }),
});
export function getRuntimeSchemaPropGuardrail(componentType, propName) {
    const canonicalType = schemaComponentIdForRuntimeComponent(componentType);
    return RUNTIME_SCHEMA_PROP_GUARDRAILS[componentType]?.[propName]
        ?? RUNTIME_SCHEMA_PROP_GUARDRAILS[canonicalType]?.[propName];
}
//# sourceMappingURL=runtime-prop-guardrails.js.map